/*
|-------------------------------------------------------------------------------
| VUEX modules/customers.js
|-------------------------------------------------------------------------------
| The Vuex data store for the customers
*/

import CustomerAPI from '../api/customer.js';

export const customers = {
	/*
    Defines the state being monitored for the module.
  */
	state: {
		customers: [],
		customersLoadStatus: 0,

		customer: {},
		customerLoadStatus: 0,

		customerEdit: {},
		customerEditLoadStatus: 0,
		customerEditStatus: 0,
		customerEditText: '',

		customerAddStatus: 0,

		customerDeleteStatus: 0
	},

	/*
    Defines the actions used to retrieve the data.
  */
	actions: {
		/*
      Loads the customers from the API
    */
		loadCustomers({ commit }) {
			commit('setCustomersLoadStatus', 1);

			CustomerAPI.getCustomers()
				.then(function (response) {
					// console.log('response: ', response);
					commit('setCustomers', response.data);
					commit('setCustomersLoadStatus', 2);
				})
				.catch(function () {
					// console.log('e: ', e);
					commit('setCustomers', []);
					commit('setCustomersLoadStatus', 3);
				});
		},

		/*
      Loads an individual customer from the API
    */
		loadCustomer({ commit }, data) {
			commit('setCustomerLoadStatus', 1);

			return CustomerAPI.getCustomer(data.id)
				.then(function (response) {
					commit('setCustomer', response.data);
					commit('setCustomerLoadStatus', 2);
					return response;
				})
				.catch(function (error) {
					commit('setCustomer', {});
					commit('setCustomerLoadStatus', 3);
					return error;
				});
		},

		/*
      Deletes an individual customer from the API
    */
		deleteCustomer({ commit, dispatch }, id) {
			commit('setCustomerDeleteStatus', 1);

			CustomerAPI.deleteCustomer(id)
				.then(function (response) {
					dispatch('loadCustomers');
					commit('setCustomer', {});
					commit('setCustomerDeleteStatus', 2);
				})
				.catch(function () {
					commit('setCustomerDeleteStatus', 3);
				});
		},

		/*
			Loads a customer to edit from the API
		*/
		loadCustomerEdit({ commit }, data) {
			commit('setCustomerEditLoadStatus', 1);

			CustomerAPI.getCustomerEdit(data.slug)
				.then(function (response) {
					commit('setCustomerEdit', response.data);
					commit('setCustomerEditLoadStatus', 2);
				})
				.catch(function () {
					commit('setCustomerEdit', {});
					commit('setCustomerEditLoadStatus', 3);
				});
		},

		/*
			Edits a customer
		*/
		editCustomer({ commit, state, dispatch }, data) {
			commit('setCustomerEditStatus', 1);
			return CustomerAPI.putEditCustomer(data.id, data.name, data.nda, data.industry_id, data.corporate_group_id)
				.then(function (response) {
					/*
								If the customer is pending because the user didn't have permission,
								set the text as pending to alert the user. Otherwise let them know
								that the edits have been approved.
						*/
					// if (typeof response.data.customer_updates_pending !== 'undefined') {
					// 	commit('setCustomerEditText', response.data.customer_updates_pending + ' updates are pending!');
					// } else {
					// 	commit('setCustomerEditText', response.data.name + ' has been successfully updated!');
					// }
					commit('setCustomerEditText', response.data.name + ' has been successfully updated!');
					/*
							Set Customer Edited Status
						*/
					commit('setCustomerEditStatus', 2);

					/*
							Load the customers
						*/
					// dispatch('loadCustomer', response.data.id);
					return response;
				})
				.catch(function (error) {
					commit('setCustomerEditStatus', 3);
					return error;
				});
		},

		/*
      Adds a new customer
    */
		addCustomer({ commit, dispatch }, data) {
			commit('setCustomerAddStatus', 1);

			return CustomerAPI.postAddNewCustomer(data.name, data.nda, data.industry_id, data.corporate_group_id)
				.then(function (response) {
					commit('setCustomer', response.data);
					commit('setCustomerAddStatus', 2);
					dispatch('loadCustomers');
					return response;
				})
				.catch(function (error) {
					commit('setCustomer', {});
					commit('setCustomerAddStatus', 3);
					return error;
				});
		}
	},

	/*
    Defines the mutations used
  */
	mutations: {
		/*
      Sets the customers load status
    */
		setCustomersLoadStatus(state, status) {
			state.customersLoadStatus = status;
		},

		/*
      Sets the customers
    */
		setCustomers(state, customers) {
			state.customers = customers;
		},

		/*
      Set the customer load status
    */
		setCustomerLoadStatus(state, status) {
			state.customerLoadStatus = status;
		},

		/*
      Set the customer
    */
		setCustomer(state, customer) {
			state.customer = customer;
		},

		/*
			Sets the customer to be edited
		*/
		setCustomerEdit(state, customer) {
			state.customerEdit = customer;
		},

		/*
			Sets the customer edit status
		*/
		setCustomerEditStatus(state, status) {
			state.customerEditStatus = status;
		},

		/*
			Sets the customer delete status
		*/
		setCustomerDeleteStatus(state, status) {
			state.customerDeleteStatus = status;
		},

		/*
			Sets the customer edit text
		*/
		setCustomerEditText(state, text) {
			state.customerEditText = text;
		},

		/*
			Sets the customer edit load status
		*/
		setCustomerEditLoadStatus(state, status) {
			state.customerEditLoadStatus = status;
		},

		/*
			Sets the customer's industries
		*/
		setCustomerAddStatus(state, status) {
			state.customerAddStatus = status;
		}
	},

	/*
    Defines the getters used by the module
  */
	getters: {
		/*
      Returns the customers load status.
    */
		getCustomersLoadStatus(state) {
			return state.customersLoadStatus;
		},

		/*
      Returns the customers delete status.
    */
		getCustomersDeleteStatus(state) {
			return state.customersDeleteStatus;
		},

		/*
      Returns the customers.
    */
		getCustomers(state) {
			return state.customers;
		},

		/*
      Returns the customers load status
    */
		getCustomerLoadStatus(state) {
			return state.customerLoadStatus;
		},

		/*
      Returns the customer
    */
		getCustomer(state) {
			return state.customer;
		},

		/*
			Gets the customer we are editing
		*/
		getCustomerEdit(state) {
			return state.customerEdit;
		},

		/*
			Gets the customer edit status
		*/
		getCustomerEditStatus(state) {
			return state.customerEditStatus;
		},

		/*
			Gets the customer edit text
		*/
		getCustomerEditText(state) {
			return state.customerEditText;
		},

		/*
			Gets the customer edit load status
		*/
		getCustomerEditLoadStatus(state) {
			return state.customerEditLoadStatus;
		},

		/*
			Gets the customer add status
		*/
		getCustomerAddStatus(state) {
			return state.customerAddStatus;
		}
	}
};
